<template>
  <div class="sb-card__content">
    <div v-if="isLoading" class="sb-card__loading">
      <SbLoading color="primary" />
    </div>
    <slot v-else></slot>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useCard } from './utils'
import SbLoading from '../Loading'

const { context } = useCard()

const isLoading = computed(() => context.value?.isLoading ?? false)
</script>
